var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"versioninfo"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"box-card-a"},[_c('div',{staticClass:"version-web"},[_vm._v("web端版本号:1.4.0316_bate")])]),_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }